export default __webpack_public_path__ + "static/media/bx_bxl-flickr.15f04597.svg";